module.exports = "/newsfeed/components/newsfeed-page-list-4acd1f.html";